import {BasicScenario} from '../../../../allkey/framework/parameters/BasicScenario';

export class ProcessScenarioExt extends BasicScenario {
manageEngines: boolean | null;
manageFlows: boolean | null;
}

